export enum MapboxStyles {
  street = 'mapbox://styles/mapbox/streets-v11',
  satellite = 'mapbox://styles/mapbox/satellite-v9',
  none = 'mapbox://sprites/projectatlas/cjgqz1eyn000g2rlbyrvc3hpi',
}
